import React from 'react';
import { spinWheelActionTypes } from '@/constants/types';
import Button from '../Button';
import SpinningWheelImage from './SpinningWheelImage';
import TextSmall from '../Typography/TextSmall';

function SpinTheWheelIconButton({ onSpin }) {
  return (
    <Button
      type="link"
      className="px-1 py-1 gap-[4px]"
      onClick={() => {
        onSpin(spinWheelActionTypes.openModal);
      }}
    >
      <SpinningWheelImage className="-mt-3" />

      <TextSmall
        text="Spin"
        className="hidden lg:block text-sm lg:text-sm lg:leading-5 text-white font-medium hover:underline"
      />
    </Button>
  );
}

export default SpinTheWheelIconButton;
